import styled from 'styled-components';

type Props = {
  text: string;
  className?: string;
};

const Text = styled.h2`
  ${(props) => props.theme.font.h2}
  color: ${(props) => props.theme.colors.secondary};
`;

const Divider = styled.div`
  margin-top: 16px;
  border-top: 1px solid #e0e0e0;
  background-color: #e0e0e0;
`;

const Subtitle: React.FC<Props> = ({ text, className }) => {
  return (
    <div className={className}>
      <Text>{text}</Text>
      <Divider />
    </div>
  );
};

export default styled(Subtitle)`
  margin-bottom: 24px;
  margin-left: ${(props) => props.theme.grid.getGridColumns(2, 1)};
  margin-right: ${(props) => props.theme.grid.getGridColumns(2, 1)};

  @media ${(props) => props.theme.breakpoints.xxl} {
    margin-left: ${(props) => props.theme.grid.getGridColumns(3, 1)};
    margin-right: ${(props) => props.theme.grid.getGridColumns(3, 1)};
  }
`;
